export default "__VITE_ASSET__12f260cd__"